/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateConfigurationRequest } from './UpdateConfigurationRequest';
import {
    UpdateConfigurationRequestFromJSON,
    UpdateConfigurationRequestFromJSONTyped,
    UpdateConfigurationRequestToJSON,
} from './UpdateConfigurationRequest';

/**
 * 
 * @export
 * @interface ModelConfiguration
 */
export interface ModelConfiguration extends UpdateConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof ModelConfiguration
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    redappName: string;
}

/**
 * Check if a given object implements the ModelConfiguration interface.
 */
export function instanceOfModelConfiguration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "redappName" in value;

    return isInstance;
}

export function ModelConfigurationFromJSON(json: any): ModelConfiguration {
    return ModelConfigurationFromJSONTyped(json, false);
}

export function ModelConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...UpdateConfigurationRequestFromJSONTyped(json, ignoreDiscriminator),
        'id': json['id'],
        'redappName': json['redappName'],
    };
}

export function ModelConfigurationToJSON(value?: ModelConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...UpdateConfigurationRequestToJSON(value),
        'id': value.id,
        'redappName': value.redappName,
    };
}

